import { render } from "./VoipTicket.vue?vue&type=template&id=08837e1e"
import script from "./VoipTicket.vue?vue&type=script&lang=js"
export * from "./VoipTicket.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "08837e1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08837e1e', script)) {
    api.reload('08837e1e', script)
  }
  
  module.hot.accept("./VoipTicket.vue?vue&type=template&id=08837e1e", () => {
    api.rerender('08837e1e', render)
  })

}

script.__file = "src/views/services/modules/voip/pills/VoipTicket.vue"

export default script